import $ from 'jquery';
const enableSaleAircraftFunctionality = () => {
    if ($('#sale-aircraft').length === 0) {
        return;
    }
    $('.carousel').carousel();
};
export default enableSaleAircraftFunctionality;
